import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const EditIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 16, height = 16, ...props }, ref) => {
    return (
      <svg
        width={width}
        height={height}
        ref={ref}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M11.1667 3.33328L13.1667 5.33328M6.50002 4.71329C5.33055 4.87991 4.26778 5.48385 3.5261 6.40328C2.78441 7.3227 2.41901 8.48919 2.50359 9.66744C2.58818 10.8457 3.11645 11.948 3.98186 12.7521C4.84727 13.5561 5.9854 14.0021 7.16669 14C8.28895 14.0001 9.37368 13.5958 10.2221 12.8611C11.0705 12.1265 11.6257 11.1107 11.786 9.99995M8.49999 9.99995L14.09 4.38995C14.3526 4.12739 14.5001 3.77127 14.5001 3.39995C14.5001 3.02863 14.3526 2.67251 14.09 2.40995C13.8274 2.14738 13.4713 1.99988 13.1 1.99988C12.7287 1.99988 12.3726 2.14738 12.11 2.40995L6.49999 7.99995V9.99995H8.49999Z"
          stroke="#1677FF"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
